function resolveApiUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  const hostname =
    typeof window !== 'undefined' && window.location.hostname
      ? window.location.hostname
      : 'localhost';
  const port = process.env.REACT_APP_API_PORT || '5001';
  return `http://${hostname}:${port}/api`;
}

export const API_URL = resolveApiUrl();

// Word-of-the-day app API (namespaced so future apps can share /api/auth).
export const WORD_API_URL = `${API_URL}/word`;

// Frontend base path for this app.
export const WORD_APP_PATH = '/word';

// Дюжина: 12 timed words.
export const DOZEN_API_URL = `${API_URL}/dozen`;
export const DOZEN_APP_PATH = '/dozen';

// Replacing a live word/dozen is for local testing only; the server refuses it in prod too.
export const IS_LOCAL_DEV = process.env.NODE_ENV === 'development';

export const HUB_PATH = '/';
export const ADMIN_HUB_PATH = '/admin';
export const PROFILE_PATH = '/profile';
